module.exports = __webpack_public_path__ + "assets/img/box2.c34ff524.png";